import { COMPONENT_NAME_PREFIX } from '../../constants';
import { AppLauncherOptionsCallback } from '../app-launcher-constants';

const elementName = `${COMPONENT_NAME_PREFIX}app-launcher-button`;

const selectors = {
  BUTTON: 'button'
};

export const APP_LAUNCHER_BUTTON_CONSTANTS = {
  elementName,
  selectors
};

export interface IAppLauncherConfig {
  optionsCallback: AppLauncherOptionsCallback;
}
